const footer = [
  // {
  //   title: "DJI Drones in India",
  //   nodes: [
  //     {
  //       title: "DJI Mini Series",
  //       nodes: [
  //         {
  //           title: "Mini 3 Pro With Smart Controller",
  //           url: "product/dji-mini-3-pro-drone-camera-with-smart-controller-2",
  //         },
  //         {
  //           title: "Mini 3 Pro With Fly More Kit Plus",
  //           url: "product/dji-mini-3-pro-drone-camera-with-fly-more-kit-plus-2",
  //         },
  //         {
  //           title: "Mini 2 Fly More Combo",
  //           url: "product/dji-mini-2-fly-more-combo-drone-2",
  //         },
  //         {
  //           title: "Mini SE Fly More Combo",
  //           url: "product/dji-mini-se-fly-more-combo-drone-camera-2",
  //         },
  //       ],
  //     },
  //     {
  //       title: "DJI Mavic Series",
  //       nodes: [
  //         {
  //           title: "Mavic Mini Standard",
  //           url: "product/dji-mavic-mini-standard-2",
  //         },
  //         {
  //           title: "DJI Mavic Mini Fly More Combo",
  //           url: "product/dji-mavic-mini-fly-more-combo",
  //         },
  //         {
  //           title: "Mavic 3 Classic with Combo Pack",
  //           url: "product/dji-mavic-3-classic-with-combo-pack-drone",
  //         },
  //         {
  //           title: "Mavic 3 Pro Fly More Combo",
  //           url: "product/dji-mavic-3-pro-fly-more-combo-drone-2",
  //         },
  //       ],
  //     },
  //     {
  //       title: "DJI Air Series",
  //       nodes: [
  //         {
  //           title: "Air 2S Fly More Combo Drone",
  //           url: "product/dji-air-2s-fly-more-combo-drone-with-normal-controller",
  //         },
  //         {
  //           title: "Air 3 Fly More Combo with Smart Controller",
  //           url: "product/dji-air-3-fly-more-combo-with-smart-controller",
  //         },
  //         {
  //           title: "Air 3 Fly More Combo with Normal Controller",
  //           url: "product/dji-air-3-fly-more-combo-with-normal-controller",
  //         },
  //       ],
  //     },
  //     {
  //       title: "DJI Enterprise Drones",
  //       nodes: [
  //         {
  //           title: "DJI Phantom 4 RTK",
  //           url: "product/dji-phantom-4-rtk-drone",
  //         },
  //         {
  //           title: "Matrice 300 RTK Drone",
  //           url: "product/matrice-300-rtk-drone-camera",
  //         },
  //         {
  //           title: "DJI Mavic 2 Enterprise Advanced",
  //           url: "product/dji-mavic-2-enterprise-advanced-drone",
  //         },
  //         {
  //           title: "DJI P4 Multispectral Drone",
  //           url: "product/dji-p4-multispectral-drone",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "DJI Drone Accessories",
    nodes: [
      {
        title: "Batteries",
        nodes: [
          {
            title: "Intelligent Flight Battery for Avata",
            url: "product/dji-intelligent-flight-battery-for-avata",
          },
          {
            title: "Intelligent Flight Battery for Mini 2",
            url: "product/intelligent-flight-battery-mini-2-mini-2-se",
          },
          {
            title: "Intelligent Flight Battery for Phantom 4 Pro",
            url: "product/dji-intelligent-flight-battery-for-phantom-4-pro",
          },
        ],
      },
      {
        title: "Remote Controllers",
        nodes: [
          {
            title: "Remote Controller for Phantom 4",
            url: "product/dji-remote-controller-for-phantom-4-pro",
          },
          {
            title: "Remote Controller for DJI Mavic 2 Pro",
            url: "product/dji-remote-controller-for-dji-mavic-2-pro",
          },
          {
            title: "Smart controller for Mavic 2 Pro",
            url: "product/dji-smart-controller-for-mavic-2-pro",
          },
          {
            title: "Remote Controller 2 For DJI FPV Drone",
            url: "product/remote-controller-2-for-dji-fpv-drone",
          },
        ],
      },
      // {
      //   title: "Propellers",
      //   nodes: [
      //     {
      //       title: "Air 2 Low-Noise Propellers",
      //       url: "product/dji-air-2-low-noise-propellers",
      //     },
      //     {
      //       title: "Mini 2 Propellers",
      //       url: "product/dji-mini-2mini-2-se-propellers-set",
      //     },
      //   ],
      // },
      // {
      //   title: "Cases",
      //   nodes: [
      //     {
      //       title: "Bag for Mini 2",
      //       url: "product/dji-carry-bag-for-mini-2mini-2-se-mini-3-with-shoulder-strap",
      //     },
      //     {
      //       title: "Mavic 3 Hard Case",
      //       url: "product/dji-mavic-3-hard-case",
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   title: "Buy Autel Drones in India",
  //   nodes: [
  //     {
  //       title: "EVO II Series",
  //       nodes: [
  //         {
  //           title: "EVO II Pro RTK V2",
  //           url: "product/evo-ii-pro-rtk-v2",
  //         },
  //         {
  //           title: "EVO II Pro Enterprise V2",
  //           url: "product/evo-ii-pro-enterprise-v2",
  //         },
  //       ],
  //     },
  //     {
  //       title: "EVO Nano Series",
  //       nodes: [
  //         {
  //           title: "EVO Lite",
  //           url: "product/autel-evo-lite",
  //         },
  //         {
  //           title: "EVO lite+",
  //           url: "product/autel-evo-lite-2",
  //         },
  //         {
  //           title: "EVO Nano",
  //           url: "product/autel-evo-nano",
  //         },
  //         {
  //           title: "EVO Nano+",
  //           url: "product/autel-evo-nano-2",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Autel Enterprise Drones",
  //       nodes: [
  //         {
  //           title: "Autel Robotics EVO II Pro",
  //           url: "product/autel-robotics-evo-ii-pro-v3-rugged-bundle-drone",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "Autel Drone Accessories",
    nodes: [
      {
        title: "Battery",
        nodes: [
          {
            title: "EVO Battery",
            url: "product/evo-battery",
          },
          // {
          //   title: "EVO II Intelligent Battery",
          //   url: "product/evo-ii-intelligent-battery-refurbished",
          // },
          // {
          //   title: "EVO Lite Series Battery",
          //   url: "product/evo-lite-series-battery",
          // },
        ],
      },
      // {
      //   title: "Filter",
      //   nodes: [
      //     {
      //       title: "EVO II UV Filter",
      //       url: "product/evo-ii-uv-filter",
      //     },
      //     {
      //       title: "EVO II Pro ND Filters",
      //       url: "product/evo-ii-pro-nd-filters",
      //     },
      //   ],
      // },
      {
        title: "Propeller",
        nodes: [
          {
            title: "EVO Lite Series Propellers",
            url: "product/evo-ii-propellers-low-noise",
          },
          {
            title: "EVO II Pro ND Filters",
            url: "product/evo-ii-pro-nd-filters",
          },
        ],
      },
    ],
  },
];

export default footer;
